import { AppId } from "../../../app/appTypes"
import { MeasureLocation, MeasurementSolairEntry } from "../measurementsApi"
import { CleanRoomClass } from "../types"

export interface ParticleLimits {
    max05um: number
    max5um: number
}

// ISO 14644-1:2015 Table 1 — maximum permitted airborne particle concentrations (at-rest, particles/m³)
export const ISO_PARTICLE_LIMITS: Partial<Record<CleanRoomClass, ParticleLimits>> = {
    'A': { max05um: 3_520,       max5um: 20 },
    'B': { max05um: 3_520,       max5um: 29 },
    'C': { max05um: 352_000,     max5um: 2_900 },
    'D': { max05um: 3_520_000,   max5um: 29_300 },
}

// ISO 14644-1 §B.4.2: minimum number of sampling locations = ceil(sqrt(area_m²))
export function minSamplingLocations(areaSqM: number): number {
    return Math.ceil(Math.sqrt(areaSqM))
}

// Calculate average concentration (particles/m³) for a location from its Solair entries.
// volume in each entry is in litres; concentration = count / (volume_L / 1000).
export function calcLocationAverages(
    entries: MeasurementSolairEntry[],
    locationId: AppId
): { avg05um: number; avg5um: number } | null {
    const relevant = entries.filter(e => e.locationId === (locationId as unknown as number))
    if (relevant.length === 0) return null

    const toConc = (count: number, volumeL: number): number =>
        volumeL > 0 ? (count / volumeL) * 1000 : 0

    const sum05 = relevant.reduce((s, e) => s + toConc(e.count05um, e.volume), 0)
    const sum5  = relevant.reduce((s, e) => s + toConc(e.count5um,  e.volume), 0)

    return {
        avg05um: Math.round(sum05 / relevant.length),
        avg5um:  Math.round(sum5  / relevant.length),
    }
}

// Returns true when both concentrations are within the class limits.
export function locationPassesLimits(loc: MeasureLocation, limits: ParticleLimits): boolean {
    if (loc.concentration05um == null || loc.concentration5um == null) return false
    return loc.concentration05um <= limits.max05um && loc.concentration5um <= limits.max5um
}
